import React, {Component} from 'react';
import {BASENAME} from "../../../constants";
import {isAllowed, ROLES, withRoles} from "../../Permissions";
import {ACTION_TYPES, actions} from "../../../actions";
import {connect} from "react-redux";
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import _ from 'lodash';
import EmphasisTab from './EmphasisTab';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { CSVLink } from "react-csv";

import { trackPromise} from 'react-promise-tracker';
import {Tab, Tabs} from "@material-ui/core";
import AssessmentTable from "../../assessments/AssessmentsTable";
import AssociateOutcomes from "./AssociateOutcomes"


const showDiv = (user, compRoles, component) => {
    if(isAllowed(user, compRoles)) {
        return component;
    } else {
        return null;
    }
};

class LinkerDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            department: {name: ''},
            program: {name: ''},
            college: {name: ''},
            courses: [],
            outcomes: [],
            visible: false,
            course: null,
            emphases: [],
            selected: '',
            data: [],
            institutionalOutcomesData:[],
            filename: '',
            associateView:false,
            tabValue:0
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    };

    renderList(list) {
        return _.map(list, option => {
            return (
                <MenuItem key={option.id} data-key={option.id} data-pid={option.pid} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>
            );
        });
    }

    handleTabChange=(e,newValue)=>{
        this.setState({associateView:newValue});
        this.setState({tabValue:newValue});
    }

    generateCSV() {
        let csvData = [];
        let headers = ['Courses'];
        let outcomeIndex = 1;

        this.state.outcomes.map(function(outcome) {
           headers.push('Outcome ' + outcomeIndex++);
        });
        csvData.push(headers);

        if(this.state.selected == 'RequiredCourses') {
            this.state.courses.map(function(course) {
                csvData.push([course.code]);
            });
            this.setState({filename: this.state.program.name})
        } else {
            let filtered = this.state.emphases.filter(emphasis => {
                return emphasis.pid == this.state.selected;
            });
            if(filtered.length > 0) {
                let emphases = filtered[0];
                emphases.requiredCourses.map(function(course) {
                    csvData.push([course.code]);
                });
                this.setState({filename: this.state.program.name + ' - ' + emphases.title + ' emphasis'})
            }

        }

        let outcomeIndex2 = 1;

        this.state.outcomes.map(function(outcome) {
            csvData.push(['Outcome ' + outcomeIndex2++ + ' \'' + outcome.id + '\'', outcome.name]);
        })
        if(this.state.selected == 'RequiredCourses') {
            csvData.push(['Kuali Program ID', this.state.program.id]);
            csvData.push(['Kuali Program PID', this.state.program.pid]);
        } else {
            let filtered = this.state.emphases.filter(emphasis => {
                return emphasis.pid == this.state.selected;
            });
            if(filtered.length > 0) {
                let emphases = filtered[0];
                csvData.push(['Kuali Program ID', this.state.program.id]);
                csvData.push(['Kuali Program PID', this.state.program.pid]);
                csvData.push(['Kuali Emphasis ID', emphases.id]);
                csvData.push(['Kuali Emphasis ID', emphases.pid]);
            }
        }
        this.setState({data: csvData});
    }

    generateInstitutionalOutcomesCSV(){
        let headers = ['Outcomes', 'Knowledge and Skills', 'Community', 'Transformation', 'Impact'];
        const programOutcomes = this.state.outcomes.map(outcome=>[outcome.name +' \'' + outcome.id +'\'']);
        this.setState({
            institutionalOutcomesData:[
                headers,
                ...programOutcomes,
                ['Kuali Program ID', this.state.program.id],
                ['Kuali Program PID', this.state.program.pid],
            ]
        })
    }

    async handleSubmit() {
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/outcomesandcourses/' + this.state.program.pid));
            this.setState({visible: false});
            if(res.status == 200) {
                let payload = await res.json();
                this.setState({courses: [...payload.courses,...payload.unrequiredCourses], outcomes: payload.programOutcomes, emphases: payload.mappedEmphases}, () => {
                    this.setState({visible: true}, () => {
                        this.generateCSV();
                        this.generateInstitutionalOutcomesCSV();
                    });
                })
            }
        } catch (err) {
            // do nothing
        }
    }

    handleChange = (name) => (event) => {
        const query = event.nativeEvent.target.getAttribute('data-key');
        const pid = event.nativeEvent.target.getAttribute('data-pid');
        switch(name) {
            case 'college':
                this.props.fetchDepartments(query).then(() => {
                        if(this.props.departments.length>0){
                            this.setState({department: this.props.departments[0]}, () => {
                                this.props.fetchPrograms(this.state.department.id)
                                    .then(() => {
                                        if(this.props.programs.length > 0) {
                                            this.setState({program: this.props.programs[0], selected: 'RequiredCourses'});
                                        }
                                    })
                            })
                        }
                    }
                )
                break;
            case 'department':
                this.props.fetchPrograms(query)
                    .then(() => {
                        if(this.props.programs.length > 0) {
                            this.setState({program: this.props.programs[0], selected: 'RequiredCourses'});
                        }
                    })
                break;
            default:
        }

        this.setState({
            [name]: {
                name: event.target.value,
                id: query,
                pid: pid
            }
        });
    };

    renderOutcomes() {
        let val = '';
        if(this.state.course) {
            val = this.state.course.id
        }
        return(<List>
            {this.state.outcomes.map(outcome => (
                <ListItem key={outcome.id + val}  dense button>
                    <ListItemText primary={outcome.name} />
                </ListItem>
            ))}
        </List>);
    }

    selectionClass = (id) => {
        // const isSelected = this.props.selectedOutcomeId === id;
        // return as json
        // return isSelected ? "selected" : "";
    };

    renderLinker() {
        if(this.state.associateView){
            // return <h1>Hi</h1>
            return <AssociateOutcomes requiredCourses={this.state.courses} programOutcomes={this.state.outcomes} selectedProgram={this.state.program}/>
            // {this.renderOutcomes()}
        }
        else if(this.state.visible) {
            return(
                <div className='row'>
                    <div className='columnLeft' style={{width: '40%'}}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h4" gutterBottom>
                                        Courses
                                    </Typography>
                                    {this.renderCourses()}
                                </CardContent>

                            </Card>
                        </div>

                        <div className='columnRight'  style={{width: '60%'}}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h4" gutterBottom>
                                        {'Program Outcomes'}
                                    </Typography>
                                    {this.renderOutcomes()}
                                </CardContent>
                            </Card>
                        </div>
                </div>
            )
        } else {
            return(<div></div>)
        }
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    filterList(list) {
        if(list && list.length > 0) {
            return list[0];
        }
        return null;
    }

    async componentDidMount() {
        if(this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.COORDINATOR)) {
            this.props.fetchColleges()
                .then(() => {
                        if(this.props.colleges.length>0){
                            this.setState({college: this.props.colleges[0]},() => {
                                    this.props.fetchDepartments(this.state.college.id)
                                        .then(() => {
                                                if(this.props.departments.length>0){
                                                    this.setState({department: this.props.departments[0]}, () => {
                                                        this.props.fetchPrograms(this.state.department.id)
                                                            .then(() => {
                                                                if(this.props.programs.length > 0) {
                                                                    this.setState({program: this.props.programs[0], selected: 'RequiredCourses'});
                                                                }
                                                            });
                                                    })
                                                }
                                            }
                                        )
                                }
                            )
                        }
                    }
                );
        } else {
            this.props.fetchDepartmentsPerUser()
                .then(() => {
                        if(this.props.departments.length>0){
                            this.setState({department: this.props.departments[0]}, () => {
                                this.props.fetchPrograms(this.state.department.id)
                                    .then(() => {
                                        if(this.props.programs.length > 0) {
                                            this.setState({program: this.props.programs[0], selected: 'RequiredCourses'});
                                        }
                                    })
                            })
                        }
                    }
                )
        }

    }

    handleToggle = (course) => {
        this.setState({
            course: {
                code: course.code,
                id: course.id,
                title: course.title,
                outcomes: course.outcomes || null,
                pid: course.pid
            }
        });
    }

    handleSwitchTabs = (pid) => {
        this.setState({
            course: null,
            selected: pid
        }, () => {
            this.generateCSV();
        })
    }

    renderCourses() {
        return(
            <div>
                <EmphasisTab courses={this.state.courses} emphases={this.state.emphases} handleToggle={this.handleToggle} handleSwitchTabs={this.handleSwitchTabs}/>
            </div>
        );
    }

    renderDownloadButton() {
        if(this.state.visible && this.state.tabValue!=1){
            return([
                <Button variant="contained" color="secondary" style={{marginLeft: '10px'}}>
                    <CSVLink style={{'text-decoration': 'none'}} data={this.state.data}  filename={`${this.state.filename}.csv`}>
                        Download CSV
                    </CSVLink>
                </Button>,
                <Button variant="contained" color="secondary" style={{marginLeft: '10px'}}>
                    <CSVLink style={{'text-decoration': 'none'}} data={this.state.institutionalOutcomesData}  filename={`${this.state.filename}_instOutcomes.csv`}>
                        Download Institutional Outcomes Data sheet
                    </CSVLink>
                </Button>
            ])
        } else {
            return(null);
        }
    }

    renderProgramSelectionForm(){
        return(
            <form>
                {showDiv(
                    this.props.user,
                    [ROLES.COORDINATOR, ROLES.ADMIN],
                    <div>
                        <TextField id="select-college" select label="Select College" style={{width:'400px'}} value={this.state.college.name} onChange={this.handleChange('college')} margin="normal">
                            {this.renderList(this.props.colleges)}
                        </TextField>
                    </div>
                )}

                <div>
                    <TextField id="select-department" select label="Select Department" style={{width:'400px'}} value={this.state.department.name} onChange={this.handleChange('department')} margin="normal">
                        {this.renderList(this.props.departments)}
                    </TextField>
                </div>

                <div>
                    <TextField id="select-program" select label="Select Program" style={{width:'400px'}} value={this.state.program.name} onChange={this.handleChange('program')} margin="normal">
                        {this.renderList(this.props.programs)}
                    </TextField>
                </div>
            </form>
            )
    }

    render() {
        return (
            <div>
                <Typography variant="h3" gutterBottom>
                    Curriculum Map
                </Typography>

                <div>
                    <div>
                        {showDiv(
                            this.props.user,
                            [ROLES.ADMIN],
                            <Tabs value={this.state.tabValue} onChange={this.handleTabChange}>
                                <Tab label="Generate CSV"/>
                                <Tab label="Associate Program Outcomes"/>
                            </Tabs>
                        )}
                        {/*<div>*/}
                        {/*    <Button href={BASENAME + "/assessments/new"} variant="contained" color="secondary" onClick={this.handleNext}>*/}
                        {/*        New Assessment*/}
                        {/*    </Button>*/}
                        {/*</div>*/}
                    </div>
                    <div>
                        {/*{!this.props.form.adminView&&<AssessmentTable/>}*/}
                        {/*{this.props.form.adminView==1&&<AssessmentTable/>}*/}
                        {/*<AssessmentTable/>*/}
                    </div>
                </div>
                <div>
                    {this.renderProgramSelectionForm()}
                </div>
                <Button variant="contained" color="secondary" onClick={this.handleSubmit}>
                    Submit
                </Button>
                {this.renderDownloadButton()}

                <div style={{marginTop: 60}}>
                    {this.renderLinker()}
                </div>
            </div>);
    }
}

function mapStateToProps(state) {
    return { user: state.user, colleges: state.colleges, departments: state.departments, programs: state.programs };
}

export default connect(mapStateToProps, actions)(withRoles([ROLES.COORDINATOR, ROLES.ADMIN, ROLES.DEPARTMENTCOORDINATOR])(LinkerDashboard));

